<template>
  <app-shell>
    <month :year="year" :month="month" />
  </app-shell>
</template>

<script>
import AppShell from '@/components/AppShell.vue'
import Month from '@/components/Month.vue'

export default {
  name: 'MonthView',

  props: ['year', 'month'],

  components: {
    AppShell,
    Month
  }
}
</script>
